import React from 'react';
import ReactDOM from 'react-dom';

import Root from './App/Root';

import './App/styles/styles.scss';

ReactDOM.render(<Root />, document.getElementById('root'));
